import { Paths } from "@app/routes";
import type { IFederatedRemoteConfig } from "./types";

/**
 * Dashboard Builder — classic webpack MF remote.
 *
 * Entry: `/dashboardui/remoteEntry.js` — container `DashboardBuilderApp`, expose `./DashboardBuilderApp`.
 * Assets: `/dashboardui/` (same-origin on deployed portals; localhost dev proxy forwards to portal).
 */
export const IDP_DASHBOARD_REMOTE: IFederatedRemoteConfig = {
  id: Paths.Dashboard,
  label: "Dashboard",
  remoteName: "DashboardBuilderApp",
  remoteType: "classic",
  exposes: ["DashboardBuilderApp"],
  url: `/${Paths.Dashboard}`,
  remoteEntryPath: "/dashboardui/remoteEntry.js",
};
